import React from 'react';

import Hero from './components/Hero';
import ContactIntro from './components/ContactIntro';

import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';


export default class extends React.Component {

  render() {
    document.title = "Diensten - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div>

        <Hero
          h1split1="Autoriteit op LinkedIn is "
          h1split2="geen toeval."
          h2 = "Met de juiste positionering en consistente content word je zichtbaar bij de mensen die ertoe doen. Ik help je dat structureel neer te zetten."
        />

        <div className="full big black">
          <div className="wrap content-block">
            <h2 style={{marginBottom:".3em"}}>Diensten</h2>
            <div className="col-2" style={{margin:"0 auto", display:"block"}}>
              <h3 style={{marginTop:"0", marginBottom:"3em"}}>Plan vandaag nog een "LinkedIn Diagnose" videobelafspraak van 15 minuten. Geen harde pitch, gewoon kijken of ik jou kan helpen.</h3>
              <div style={{textAlign:"center"}}><a href="https://calendar.app.google/XPw5Ho3npLVVWrSD9" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-gold">Plan 15 minuten in</a> <a href="https://calendar.app.google/XPw5Ho3npLVVWrSD9" target="blank"><img src={img_me} alt="Ghostin.nl LinkedIn Ghostwriter | Peter van der Meer" style={{marginTop:"-36px", marginLeft:"14px", borderRadius:"50%", border:"3px solid #E5C88D", width:"90px"}} /></a></div>
            </div>

            <div className="col-3" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>De Fundering</h3>
                <p style={{marginBottom:"1em"}}>De kern van De Fundering is een zeer uitgebreide Strategie Sessie waarin wij jouw positionering en uitdagingen bespreken voor LinkedIn. Als resultaat krijg jij meerdere uitgebreide documenten die als basis dienen voor een sterk profiel dat de berichten en artikelen effectiever maakt.</p>
                <p style={{fontWeight:"bold"}}>Eenmalig:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>Strategie Sessie (90 min.){/* t.w.v. 1297*/}</li>
                  <li>Kernverhaal & Positioneringsdocument</li>
                  <li>LinkedIn Architectuur Plan</li>
                  <li>Briefing voor de Ghostwriter</li>
                  <li>Herschreven LinkedIn Profiel</li>
                  <li>BONUS: 4 berichten met deze basis</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor wie aan het begin staat van het bewust bouwen aan autoriteit.</p>
                  {/*<p style={{marginTop:"1em",fontSize:"85%"}}>Eenmalig <span style={{color:"#8bc34a"}}>2847</span></p>*/}
                </div>
              </div>
            </div>
            <div className="col-3" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Autoriteit Bouwer</h3>
                <p style={{marginBottom:"1em"}}>Als kern zijn dit gerichte berichten die sturen hoe jij gezien wordt. Voor professionals die hun berichten willen laten kloppen met hun expertise en hun niveau. Geen opvulling, maar doelgerichte en strategische posts die bijdragen aan autoriteit, herkenbaarheid, en uitstraling.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>Wekelijks strategische berichten</li>
                  <li>Contact via LinkedIn, e-mail, en 06</li>
                  <li>1x strategie en analyse videobelafspraak</li>
                  <li>1x per 12 weken profiel en positionering optimalisatie</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor wie actief wil bouwen aan autoriteit, maar de regie nog niet volledig wil uitbesteden.</p>
                </div>
              </div>
            </div>
            <div className="col-3" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Thought Leader Add-on</h3>
                <p style={{marginBottom:"1em"}}>Voor bestaande klanten is er de optie om de "Thought Leader Add-on" af te nemen. Dit zijn artikelen die als nieuwsbrieven op LinkedIn geplaatst worden. Artikelen zijn erg interessant omdat dit mensen aantrekt die al geïnteresseerd zijn in jouw berichten.</p>
                <p style={{fontWeight:"bold"}}>Iedere vier weken:</p>
                <ul style={{listStyleType:"square", paddingLeft:"1.1em", fontWeight:"bold", fontSize:"1.3em"}}>
                  <li>1-4 artikelen</li>
                  <li>Op basis van De Fundering</li>
                  <li>Aanvullend op de wekelijkse berichten</li>
                </ul>
                <div style={{fontSize:"1.2em"}}>
                  <p style={{marginTop:"1em"}}>Perfect voor: bestaande klanten die verder aan "Thought Leadership" willen werken.</p>
                </div>
              </div>
            </div>
            {/*<small style={{marginBottom:".3em", marginTop:"1em", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>prijzen zijn exclusief 21% BTW.</small>*/}

          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Services.js